import { useState, useCallback } from "react";
import validateFile from "../Components/Common/FilesRelevent/validateFile";
import { urtoast } from "../Components/Layouts/CustomPopup/eventEmitter";

/**
 * Custom hook to handle file validation logic globally.
 * @returns {Object} { validating, validateFiles }
 */
export const useFileValidator = () => {
    const [validating, setValidating] = useState(false);

    /**
     * Validates one or more files using the backend API.
     * @param {File|File[]} files - The files to validate.
     * @returns {Promise<boolean>} - True if validation passes, false otherwise.
     */
    const validateFiles = useCallback(async (files) => {
        if (!files || (Array.isArray(files) && files.length === 0)) return true;
        // User requested to remove file check API locally
        return true;
    }, []);

    return { validating, validateFiles };
};

export default useFileValidator;
